import React from 'react';

const TRIGGERS = [
  { label: 'סטרס בעבודה', value: 'work_stress', emoji: '💼' },
  { label: 'בדידות', value: 'loneliness', emoji: '🌑' },
  { label: 'עייפות', value: 'fatigue', emoji: '😴' },
  { label: 'כעס', value: 'anger', emoji: '😡' },
  { label: 'שעמום', value: 'boredom', emoji: '😑' },
  { label: 'חרדה', value: 'anxiety', emoji: '😰' },
  { label: 'לחץ חברתי', value: 'social_pressure', emoji: '👥' },
  { label: 'עצב', value: 'sadness', emoji: '😢' },
  { label: 'אחר', value: 'other', emoji: '❓' },
];

const TriggerSelector = ({ selected = [], onToggle }) => {
  return (
    <div className="bg-white rounded-xl p-4 border border-stone-200">
      <p className="text-sm font-semibold text-stone-700 mb-3">
        🎯 מה מרגיש קשה היום?
      </p>
      <div className="flex flex-wrap gap-2">
        {TRIGGERS.map((trigger) => {
          const isSelected = selected.includes(trigger.value);
          return (
            <button
              key={trigger.value}
              onClick={() => onToggle(trigger.value)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${
                isSelected
                  ? 'bg-orange-500 text-white shadow'
                  : 'bg-orange-50 text-orange-700 hover:bg-orange-100 border border-orange-200'
              }`}
            >
              <span>{trigger.emoji}</span>
              <span>{trigger.label}</span>
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <p className="text-xs text-stone-500 mt-2">
          {selected.length} טריגר{selected.length > 1 ? 'ים' : ''} נבחר{selected.length > 1 ? 'ו' : ''}
        </p>
      )}
    </div>
  );
};

export { TRIGGERS };
export default TriggerSelector;
